import React from 'react';

const GroupChannel = ({ register, getValues }) => {
  const channels = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  const numberOfChannels =
    getValues('products.group_channel.settings.number_of_channels');

  return (
    <>
      <label className="col-md-3 control-label">Number of Channels:</label>
      <div className="col-md-2">
        <select
          defaultValue={numberOfChannels}
          className="form-control"
          {...register('products.group_channel.settings.number_of_channels', {
            valueAsNumber: true,
            value: 1,
          })}
        >
          {channels.map((n) => (
            <option key={`channel${n}`} value={n}>
              {n}
            </option>
          ))}
        </select>
      </div>
    </>
  );
};

export default GroupChannel;
